import { ICompaniesData, ICompanyItem, ICompanyItemDetails } from '@company/components/CompaniesList/ICompaniesList';
import * as H from 'history';
import { TFundingData } from '@company/components/Funding/IFunding';
import { ITeamMember } from '@company/components/FollowCompany/IFollowCompany';
import noPhotoCompany from '@images/no_photo_company.png';

class CompaniesPageMockServiceClass {

  public getBrowserHistory() : H.History {
    return  {
      length: 47,
      action: 'PUSH',
      location: {
        pathname: '/test',
        search: '',
        hash: '',
        key: 'dobazn',
        state: '',
      },
      block: jest.fn(),
      createHref: jest.fn(),
      go: jest.fn(),
      goBack: jest.fn(),
      goForward: jest.fn(),
      listen: jest.fn(),
      push: jest.fn(),
      replace: jest.fn(),
    };
  }

  public getCompanyReducer() : ICompanyItemDetails {
    return {
      avatar: { id: null, url: null },
      categories: '',
      description: '',
      founded: undefined,
      funding_to_date: [],
      id: 0,
      slug: '',
      investor_id: undefined,
      labels:[],
      location: {
        country: '',
        country_name: '',
        city: '',
      },
      cover_photo: {
        id: '',
        url: '',
      },
      markets: [],
      managed_by_community_notice: null,
      name: '',
      legal_name: null,
      social_media: {},
      stage: null,
      creator_id: null,
      profile_id: null,
      current_user_investor_access: null,
      total_raised: 0,
      live_pitch: null,
      total_followers: 0,
      current_user_can_deposit: true,
      trading_asset_id: 0,
      trading_spv_id: 0,
    };
  }

  public getCompanyItem() : ICompanyItem {
    return{
      avatar: { id: '', url: 'avatar.jpg' },
      categories: '',
      description: '',
      founded: undefined,
      funding_to_date: [],
      id: 300,
      slug: 'test-slug',
      labels: ['',''],
      live_pitch: null,
      location: {
        country: '',
        country_name: '',
        city: '',
      },
      cover_photo: { id: '', url: '' },
      managed_by_community_notice: '',
      name: 'Test Name',
      legal_name: 'Legal name',
      markets: ['pre-listed'],
      social_media: {},
      stage: '',
      investor_id: undefined,
      profile_id: null,
      creator_id: null,
      total_raised: 1000,
      total_followers: 5,
      current_user_can_deposit: true,
      trading_asset_id: 2,
      trading_spv_id: 122,
    };
  }

  public getCompanyItemDetails() : ICompanyItemDetails {
    return {
      id: 2816,
      slug: 'test-slug2',
      name: 'Fajna Ltd',
      legal_name: 'Legal name',
      description: null,
      location: {
        country: 'GB',
        country_name: 'Great Britain',
        city: 'Curdiff',
      },
      founded: undefined,
      funding_to_date: [],
      labels: [],
      live_pitch: null,
      social_media: {
        website: 'http://www.google.pl',
      },
      avatar: {
        id: '2',
        url: noPhotoCompany,
      },
      cover_photo: {
        id: '2',
        url: noPhotoCompany,
      },
      markets: ['Test'],
      categories: '',
      managed_by_community_notice: null,
      stage: '1',
      investor_id: 1,
      creator_id: 0,
      profile_id: 0,
      current_user_investor_access: true,
      total_raised: 0,
      total_followers: 0,
      current_user_can_deposit: true,
      trading_asset_id: 2,
      trading_spv_id: 122,
    };
  }

  public getCompanyMembers() : ITeamMember {
    return {
      avatar: '//bttf-dev.s3.amazonaws.com/Users/arturkosorz/RubymineProjects/' +
        'BankToTheFuture/private/photos/46111/original/any.',
      editable: false,
      id: 564,
      linkedin_page: null,
      name: 'Name67000',
      profile_id: 46111,
      role: null,
      type: 'CompanyCollaborator',
    };
  }

  public getCompanies() :  ICompanyItem[] {
    return [
      {
        id: 2871,
        slug: 'test-slug',
        name: 'Conrivo Mateusz Woźniak',
        legal_name: 'Legal name',
        description: 'Company description visible on public',
        location: {
          country: 'GB',
          country_name: 'Curdiff',
          city: 'CITY',
        },
        founded: undefined,
        funding_to_date: [],
        labels: [],
        live_pitch: null,
        social_media: {
          website: 'http://google.pl',
        },
        avatar: {
          id: '1',
          url: noPhotoCompany,
        },
        cover_photo: {
          id: '1',
          url: noPhotoCompany,
        },
        categories: 'INDUSTRY',
        markets: ['pre-listed'],
        managed_by_community_notice: null,
        stage: '0',
        investor_id: 1,
        creator_id: 0,
        profile_id: 0,
        total_raised: 0,
        total_followers: 2,
        current_user_can_deposit: true,
        trading_asset_id: 2,
        trading_spv_id: 122,
      },
      {
        id: 2816,
        slug: 'test-slug',
        name: 'Fajna Ltd',
        legal_name: 'Legal name',
        description: null,
        location: {
          country: 'GB',
          country_name: '',
          city: '',
        },
        founded: undefined,
        funding_to_date: [],
        labels: [],
        live_pitch: null,
        social_media: {
          website: 'http://www.google.pl',
        },
        avatar: {
          id: '2',
          url: noPhotoCompany,
        },
        cover_photo: {
          id: '2',
          url: noPhotoCompany,
        },
        categories: '',
        markets: ['pre-listed'],
        managed_by_community_notice: null,
        stage: '1',
        investor_id: 1,
        creator_id: 0,
        profile_id: 0,
        total_raised: 0,
        total_followers: 10,
        current_user_can_deposit: true,
        trading_asset_id: 3,
        trading_spv_id: 123,
      },
    ];
  }

  public getCompaniesData(returnEmpty: boolean = false) : ICompaniesData {
    return {
      items: returnEmpty ? [] : this.getCompanies(),
      page: 1,
      per_page: 25,
      total_count: 0,
      total_pages: 0,
    };
  }

  public getFundingData(): TFundingData[] {
    return [
      {
        id: 2,
        date: '19/03/2007',
        name: 'Some found round',
        money_raised: '192',
        funding_type: 'other',
        share_price: '123',
      },
      {
        id: 3,
        date: '19/03/2019',
        name: 'Newest funding round',
        money_raised: '421221',
        funding_type: 'other',
        share_price: '12345',
      },
    ];
  }
}

const CompaniesPageMockService = new CompaniesPageMockServiceClass();

export default CompaniesPageMockService;
